export default {
  home: {
    banner: {
      title: "Customer Stories",
      "title-first": "The success of customer",
      "title-second": "is the success of Authing",
      subtitle:
        "Authing provides cost-effective identity authentication and access management services for customers in different industries and countries, creating better experience for each service.",
      "data-label-count": "Number",
      "data-label-industry": "Industry involved",
      "data-label-time": "Service time",
    },
    example: {
      "heigh-educate": {
        title:
          "Higher Education Press - the way of transformation of traditional enterprises",
        subtitle:
          "Higher education press is a member of China Education Publishing Media Group Co., Ltd. It is a comprehensive large-scale publishing house which mainly publishes educational, professional and technological publications such as higher education, vocational education, adult and social education. This portal provides enterprise information, published books, digital products and courses, and teaching resources information.",

        label1: "Education",
        label2: "B2C",
      },
    },
    cardList: {
      title: "Understand our customer story",
      item1: {
        title: "Higher Education Press",
        text:
          "Authing helps Higher Education Press to build a smart identity platform to bring users the most convenient, most comfortable, and most suitable login experience.",
      },
      item2: {
        title: "Yuanqi forest",
        text:
          "Authing saves 80% of the operation and maintenance workload of Yuanqi Forest by implementing different access levels based on the Feishu organizational structure.",
      },
      item3: {
        title: "CNPN",
        text:
          "Authing provides a full set of C# SDK to satisfy PetroChina's quick access to its R&D system.",
      },
      item4: {
        title: "Southeast University",
        text:
          "Authing uses a cross-platform SDK and uses five lines of code to help Southeast University implement a cross-platform user system (including applets).",
      },
      item5: {
        title: "Volkswagen",
        text:
          "Authing federal certification helps Volkswagen establish trust between upstream and downstream partners and application providers through standard protocols.",
      },
      item6: {
        title: "Bentley Motors",
        text:
          "Authing helps Bentley Motors to easily process any user login data, which indirectly greatly improves the efficiency of R&D work.",
      },
      item7: {
        title: "Toyota",
        text:
          "Authing helps Toyota quickly integrate their new and old applications, greatly reducing the development cycle and time to market for new applications.",
      },
      item8: {
        title: "JCDecaux",
        text:
          "Authing built a unified authentication center for JCDecaux, helping JCDecaux complete identity management and equipment management services",
      },
      item9: {
        title: "BOSCH",
        text:
          "Authing uses a scalable and highly-scalable SaaS platform deployment model, which greatly shortens the R&D cycle of the Bosch Group.",
      },
      item10: {
        title: "PingCAP",
        text:
          "Authing's product capabilities for identity management and data synchronization have helped PingCAP greatly reduce operation and maintenance costs.",
      },
      item11: {
        title: "West China Hospital of Sichuan University",
        text:
          "Authing built an identity system for West China Hospital to reduce information security risks caused by irregular personnel identity management.",
      },
      item12: {
        title: "Bentley",
        text:
          "Authing guarantees the security of Bentley's internal developers and external users during login and authentication.",
      },
      item13: {
        title: "Nreal",
        text:
          "For Nreal, Authing provides 1000+ APIs and SDKs to quickly implement unified identity across 3 platforms.",
      },
      item14: {
        title: "SEER",
        text:
          "Authing has implemented identity management for SEER, greatly saving development time and effort.",
      },
      item15: {
        title: "Alpha Cen",
        text:
          "Authing simplifies Alpha Cen's identity management by providing API/SDK for various engineering software and platforms.",
      },
      item16: {
        title: "CSDN",
        text:
          "Authing provides 32 social login capabilities, and 1000+ APIs/SDKs, helping CSDN shorten a month of development cycle.",
      },
      item17: {
        title: "UniCredit",
        text:
          "Authing offers MFA and adaptable security policies for enhanced identity management security in enterprises.",
      },

      // item12: {
      //   title: "Coca Cola",
      //   text:
      //     "Authing helps Coca-Cola realize corporate WeChat scan code login, solve the pain points of employees' multi-account, multi-application switching login, improve employee satisfaction and experience.",
      // },
      // item1: {
      //   title: "TOYOTA",
      //   text:
      //     "Toyota is one of the top ten auto companies in the world. It is the largest auto company in Japan. Founded in 1933, it has developed into a huge industrial group focusing on auto production and involving machinery, electronics, finance and other industries.",
      //   allText:
      //     "Toyota is one of the top ten auto companies in the world. It is the largest auto company in Japan. Founded in 1933, it has developed into a huge industrial group focusing on auto production and involving machinery, electronics, finance and other industries. Authing provides a unified identity security management platform for users and helps Toyota manage large-scale user growth.",
      // },

      // item2: {
      //   title: "China Merchants Bank",
      //   text:
      //     "China Merchants Bank, established in 1987, is the first joint-stock commercial bank in China to be wholly owned by an enterprise legal person. By the end of 2019, China Merchants Bank has a total market value of 939.9 billion yuan, ranking among the top ten in the global banking industry.",
      //   allText:
      //     "China Merchants Bank, established in 1987, is the first joint-stock commercial bank in China to be wholly owned by an enterprise legal person. By the end of 2019, China Merchants Bank has a total market value of 939.9 billion yuan, ranking among the top ten in the global banking industry. Authing helps China Merchants Bank improve its internal unified identity management ability, greatly reduce the operation and maintenance costs, and accelerate the business success.",
      // },
      // item3: {
      //   title: "Kingdee",
      //   text:
      //     "Kingdee International Software Group is a leading online management and e-commerce service provider in the world. Kingdee has provided services to 6.8 million enterprises and governments around the world through management software and cloud services.",
      //   allText:
      //     "Kingdee International Software Group is a leading online management and e-commerce service provider in the world. Kingdee has provided services to 6.8 million enterprises and governments around the world through management software and cloud services. Authing provides a unified identity authentication platform to help Kingdee manage user identity efficiently.",
      // },
      // item4: {
      //   title: "Southeast University",
      //   text:
      //     'Southeast University is a national key university directly under the Ministry of education, and one of the key construction universities of the national "985 Project" and "211 Project"',
      //   allText: `Southeast University is a national key university directly under the Ministry of education of the people's Republic of China. It is one of the key construction universities of the national "985 Project" and "211 Project". Through Authing, single sign on of cross platform user system is realized with only five lines of code.`,
      // },
      // item5: {
      //   title: "Bentley",
      //   text:
      //     "Bentley Engineering Software Co., Ltd., founded in 1984, employs more than 4000 people and has branches in 172 countries around the world, with an annual revenue of more than US $800 million. It is rated as the world's second largest provider of geographic information software solutions.",
      //   allText: "",
      // },

      // item6: {
      //   title: "EY",
      //   text:
      //     "EY (Ernst & Young) is one of the world's four largest accounting firms and one of the largest professional service organizations in Greater China. ",
      //   allText:
      //     "EY (Ernst & Young) is one of the world's four largest accounting firms and one of the largest professional service organizations in Greater China. It has provided professional services in the region for 40 years. During this period, Ernst & Young achieved a number of milestone developments: Ernst & Young’s predecessor, Yate Young, established its first office in Hong Kong in 1968; Ernst & Young became the first international professional service provider approved to conduct business in Mainland China in 1981. One of the institutions.",
      // },
      // item7: {
      //   title: "THERAGUN",
      //   text:
      //     "Theragun is also one of the best sports rehabilitation brands. It has been deeply cultivated in the field of percussive massage for nearly 10 years.",
      //   allText:
      //     "Theragun is also one of the best sports rehabilitation brands. It has been deeply cultivated in the field of percussive massage for nearly 10 years. Theragun is used by more than 250 professional sports teams around the world. Authing provides cloud identity security management services to solve the identity management problems of internal and external users.",
      // },
      // item8: {
      //   title: "PetroChina",
      //   text:
      //     "PetroChina is one of the key state-owned enterprises and one of the main oil and gas producers and suppliers in China, and it is the leading position in the domestic oil and gas exploration and development.",
      //   allText:
      //     "PetroChina is an important state-owned backbone enterprise and one of the main oil and gas producers and suppliers in China. It plays a leading role in domestic oil and gas exploration and development. Authing provides a perfect single sign on platform to help PetroChina quickly realize efficient user management.",
      // },
      // item9: {
      //   title: "Higher Education Society",
      //   text:
      //     "Founded in May 1954, higher education press is one of the earliest professional education publishing institutions in New China.",
      //   allText:
      //     "Founded in May 1954, higher education press is one of the earliest professional education publishing institutions in New China. Authing helps higher education press quickly integrate tens of millions of users to complete a comfortable and smooth login experience.",
      // },
      // item10: {
      //   title: "State Grid",
      //   text:
      //     "State Grid Co., Ltd., established in 2002, is a large state-owned key backbone enterprise related to the lifeline of national economy and national energy security.",
      //   allText:
      //     "State Grid Co., Ltd., established in 2002, is a large state-owned key backbone enterprise related to the lifeline of national economy and national energy security. By providing perfect identity management services, Authing helps State Grid to realize identity governance in an all-round way, enhance information security and strengthen risk control.",
      // },

      // item11: {
      //   title: "PingCap",
      //   text:
      //     "Founded in 2015, PingCAP is an enterprise-level open source distributed database vendor, providing open source distributed database products, solutions and consulting, technical support and training certification services.",
      //   allText:
      //     "Founded in 2015, PingCAP is an enterprise-level open source distributed database vendor, providing open source distributed database products, solutions and consulting, technical support and training certification services, and is committed to providing stable, efficient, safe, reliable, and open for global industry users Compatible new data infrastructure, liberating enterprise productivity, and accelerating enterprise digital transformation and upgrading.",
      // },
      // item12: {
      //   title: "JCDecaux Group",
      //   text:
      //     "JCDecaux group, founded in 1964, is the world's first international outdoor media company and listed in Euronext, Paris.",
      //   allText:
      //     "JCDecaux group, founded in 1964, is the No.1 international outdoor media company in the world and listed in Euronext in Paris. Authing helps enterprise users quickly access the enterprise internal application system to complete account synchronization, single sign on and access authorization.",
      // },
      // item13: {
      //   title: "Testin",
      //   text:
      //     "Testin founded in 2011, is an enterprise service platform driven by artificial intelligence technology. More than one million cloud developers around the world provide testing, testing, data tagging and security services.",
      //   allText:
      //     "Testin founded in 2011, is an enterprise service platform driven by artificial intelligence technology. More than one million cloud developers around the world provide testing, testing, data tagging and security services. The cloud identity security management service provided by Authing solves the pain points of multiple accounts, multiple passwords and multiple access.",
      // },
      // item14: {
      //   title: "Yuanqi Forest",
      //   text: `Founded in 2016, Yuanqi Forest is an innovative beverage brand independently developed and designed.In just 5 years, it has taken the lead in the sugar-free soft drink market and topped the "China Business News" gold signature carbonated drinks list. `,
      //   allText: `Founded in 2016, Yuanqi Forest is an innovative beverage brand independently developed and designed. In just 5 years, it has taken the lead in the sugar-free soft drink market and topped the "China Business News" gold signature carbonated drinks list. Its business not only covers the whole country, but also exports to more than 40 countries such as the United States, New Zealand, and Singapore. area.`,
      // },
      // item15: {
      //   title: "Bentley",
      //   text:
      //     "Bentley, a British luxury car brand, is headquartered in Crewe, England. In 1919, Mr. W.O. Bentley founded the Bentley Motor Company.",
      //   allText: `Bentley, a British luxury car brand, is headquartered in Crewe, England. In 1919, Mr. W.O. Bentley founded the Bentley Motor Company. "To build a fast car, a good car, the best in its class." was the founder Walter Irving Bentley Mr. initially pursued the ultimate and excellent car-making concept.`,
      // },
      // item16: {
      //   title: "Volkswagen",
      //   text:
      //     "Volkswagen is an automobile manufacturing company headquartered in Wolfsburg, Germany, and a core enterprise of the Volkswagen Group, one of the world's four largest automobile manufacturers. ",
      //   allText: `Volkswagen is an automobile manufacturing company headquartered in Wolfsburg, Germany, and a core enterprise of the Volkswagen Group, one of the world's four largest automobile manufacturers. In 2019, it ranked 9th in the Fortune Global 500. Volks means "national" in German, Wagen means "car" in German, and the full name means "national car", so it is often abbreviated as "VW". `,
      // },
      // item17: {
      //   title: "Treelab",
      //   text:
      //     "Treelab was founded in 2019. At first, the founding team found that businesses ranging from billions of dollars in revenue to individual stores were using manual or Excel to record management business. ",
      //   allText:
      //     "Treelab was founded in 2019. At first, the founding team found that businesses ranging from billions of dollars in revenue to individual stores were using manual or Excel to record management business. The birth of Treelab is to stimulate everyone's creativity, so that people who are not good at technology can flexibly build their own office tools according to their own business scenarios.",
      // },
    },
  },
  "heigh-educate": {
    banner: {
      title: "Higher Education Press",
      subtitle:
        "Authing helps the higher education press build a smart identity platform to bring the most convenient, comfortable and suitable login experience to users.",
      brandDescript: `"Compared with many manufacturers, we can feel the advantages of Authing. It's a product made through thinking."`,
    },
    intro: {
      title: "Customer Introduction",
      imgUrl: "//files.authing.co/authing-website/customer-intro-hep-en.png",
      descript1:
        "Founded in May 1954, the higher education press is one of the earliest professional education publishing institutions in New China. At present, the higher education society has more than 1700 employees, more than 10000 kinds of books published every year, and nearly 130 million copies issued. The scale of the publishing house and the number of employees are at the forefront of domestic publishing houses.",
      descript2:
        "Under the leadership of the Ministry of education, the higher education society undertakes the construction and operation of the national ideological and political work network of colleges and universities and China University Students online. At present, the ideological and political network has covered the education departments of provincial Party committees, 75 colleges and universities directly under the Ministry of Education, other ministries and universities, and 2500 local colleges and universities. The total number of online website members of Chinese college students has reached 11.2 million, a new record.",
      descript3:
        "The higher education society has carried out extensive cooperation with more than 200 institutions around the world, including many well-known publishers. 24 language versions of international products have been distributed in more than 60 countries in the world, and the number of copyright output has ranked among the top single publishing houses in China for years. It has been rated as a key national cultural export enterprise for many times.",
    },
    challenge: {
      title: "Customer Challenges",
      item1: {
        title: "Challenge 1",
        description:
          "The 35 million users of higher education society are distributed in dozens of software platforms, and its management is complex.",
      },
      item2: {
        title: "Challenge 2",
        description:
          "Higher education society needs an excellent user login experience to improve cooperation with the domestic education market and international publishers.",
      },
      item3: {
        title: "Challenge 3",
        description:
          "To undertake the construction of Ideological and political networks means that fraud prevention and security are particularly important.",
      },
      item4: {
        title: "Challenge 4",
        description:
          "With the operation of Ideological and political networks, college student's online networks, higher education society has a strong demand for cross-brand single sign-on.",
      },
    },
    ideas: {
      title: "How Authing Solves",
      item1: {
        title: "Comfortable user experience",
        subtitle:
          "In cooperation with higher education society, the Authing team provides one-to-one consulting and technical services throughout the whole process to speed up the online website, and empowering HSS with Authing SDKs such as Java, Delphi, support the success of customers.",
      },
      item2: {
        title: "Guarantee the security of enterprise identity information",
        subtitle:
          "By providing Adaptive MFA, login environment monitoring and other security technologies, Authing creates professional security protection for higher education society.",
      },
      item3: {
        title: "Perfect identity service",
        subtitle:
          "With the perfect identity authentication and access management services of Authing, the two engineers completed the deployment test in one afternoon, and easily integrated tens of millions of users of higher education society. Realize the experience of cross-brand login in one place and with one account.",
      },
      item4: {
        title: "Improve the scalability of the system",
        subtitle:
          "The Authing platform is flexible and rich in documents and software packages. In the rapid development of higher education society, provides the ability of expansion and integration, reduces daily maintenance, reduces the development cost in the future, creates an efficient and pleasant development mode, simplifies it management and accelerates business growth.",
      },
    },
  },
  cnpn: {
    banner: {
      title: "CNPN",
      subtitle:
        "Authing provides a perfect single sign-on platform to help PetroChina quickly realize efficient user management.",
    },
    intro: {
      title: "Customer Introduction",
      imgUrl: "//files.authing.co/authing-website/customer-intro-cnpn-en.png",
      descript1:
        "CNPC is an important state-owned backbone enterprise and one of the main oil and gas producers and suppliers in China. It is a comprehensive international energy company integrating oil and gas exploration and development, refining and chemical industry, sales and trade, pipeline storage and transportation, engineering technology, engineering construction, equipment manufacturing, and financial services. It occupies a leading position in domestic oil and gas exploration and development, and plays a leading role in the world 35 countries and regions carry out oil and gas business.",
      descript2:
        "In 2020, the company will rank third among the world's 50 major oil companies and fourth among Fortune's 500 major companies.",
    },
    challenge: {
      title: "Customer Challenges",
      item1: {
        title: "Challenge 1",
        description:
          "The Research Institute of PetroChina has a total of more than 1000 people and uses more than 10 software services, which makes it management complex.",
      },
      item2: {
        title: "Challenge 2",
        description:
          "The company hopes that its members can log in to all software by using the company's account. However, the existing business system is old and difficult to innovate in security and authentication.",
      },
      item3: {
        title: "Challenge 3",
        description:
          "The core function research and development itself has taken a long time, but the user verification function has not been improved. The company hopes to speed up the research and development cycle.",
      },
    },
    ideas: {
      title: "How Authing Solves",
      item1: {
        title: "Comfortable user experience",
        subtitle:
          "Authing provides a perfect single sign-on platform, which quickly realizes user authentication and access management functions for its web and app.",
      },
      item2: {
        title: "Guarantee the security of enterprise identity information",
        subtitle:
          "Authing provides a full set of C # SDKs to meet PetroChina's rapid access to its R&D system.",
      },
      item3: {
        title: "Perfect identity service",
        subtitle: `On the mobile terminal single sign-on, which is the focus of CNPC, Authing has the following features: automatic detection of login status of associated applications on the same device, and "arousing associated app to exchange user information", which facilitates CNPC to make choices based on scenarios.`,
      },
    },
  },
  dongnan: {
    banner: {
      title: "Southeast University",
      subtitle:
        "The five-element code helps Southeast University realize the single sign-on of cross-platform user system.",
    },
    intro: {
      title: "Customer Introduction",
      imgUrl:
        "//files.authing.co/authing-website/customer-intro-dongnan-en.png",
      descript1: `Southeast University, located in Nanjing, the ancient capital of the Six Dynasties, is a famous institution of higher learning at home and abroad. The university is a national key university directly under the Ministry of education of the people's Republic of China and jointly built with Jiangsu Province. It is one of the key universities under the "985 Project" and "211 Project" of the people's Republic of China.`,
      descript2:
        "At present, Southeast University has 33 departments and 77 undergraduate majors, with 33 first-class doctoral degree authorization points and 49 first-class master degree authorization points. There are 30664 full-time students, including 16128 undergraduates and 14536 postgraduates, and 1989 international students, including 1547 international students with academic qualifications. The school has Sipailou, Jiulong Lake, Dingjiaqiao, and other campuses, covering an area of 5,888 acres, of which the Jiulong Lake campus is 3,752.35 acres, with a total construction area of about 789,700 square meters.",
    },
    challenge: {
      title: "Customer Challenges",
      item1: {
        title:
          "Southeast University encountered the problem of single sign-on in the development of the BIM system. It needs to unite the self-developed system (BIM system) and the tripartite system (odoo, strapi, C9. IO) for unified authentication and authorization. However, the research and development of the BIM system itself are extremely complex. If the research and development of single sign-on are carried out at the same time, it will slow down the online speed of the project and ultimately affect the use of site staff. Also the BIM system has not only the web side but also the small program side. The research and development of multi-terminal and cross-platform user systems will introduce other complex problems. Besides, due to the complexity of BIM organization and the need for fine-grained authority classification, the research and development of a role-based authorization model will slow down the online speed of the system.",
        description: "",
      },
    },
    ideas: {
      title: "How Authing Solves",
      item1: {
        title: "",
        subtitle:
          "Authing attaches importance to the education market, provides one-to-one consulting and technical services for Southeast University, accelerates its system to go online and supports business success.",
      },
      item2: {
        title: "",
        subtitle:
          "Authing uses OAuth 2.0-based single sign-on scheme to connect BIM system with odoo, strapi and c9.io; uses RBAC-based authorization scheme to unify the authorization classification of organizations and staff; uses Cross-Platform SDK（Java、Delphi、C#、Node）to realize cross-platform user system (including small programs) with five lines of code.",
      },
    },
  },
  "xian-gong": {
    banner: {
      title: "SEER Ltd",
      subtitle: `We highly value the flexibility and reliability of suppliers. Authing's "Embed, Integrate, Connect" approach aligned perfectly with our needs. We used Authing for both employee and customer identity management, which saved us a lot of time and effort.`,
    },
    intro: {
      title: "Customer Introduction",
      imgUrl:
        "//files.authing.co/authing-website/customer-story-detail-intro-xiangong-en.png",
      descript1:
        "SEER is a high-tech company that specializes in intelligent manufacturing and smart logistics. They offer various types of AMRs such as an AMR controller, a digital platform, a factory collaboration solution, and an automatic forklift. SEER provides one-stop logistics solutions for different industries and supports non-standard applications. Their focus is to promote industrial transformation and upgrading through informatization, digitalization, and intelligence.",
      descript2:
        "From discovering needs to solving needs, from solving needs to creating needs, SEER insists on finding breakthroughs in customer needs and its own multi-level needs, focusing on industrial intelligence, conducting open innovation, and creating value for partners.",
    },
    challenge: {
      title: "Customer Challenges",
      item1: {
        title: "Problem 1",
        description:
          "Enterprise application systems are dispersed, leading to isolated data and difficulty in unified identity management. This creates a data island effect.",
      },
      item2: {
        title: "Problem 2",
        description:
          "As business grows and more people are hired, managing and allocating employee permissions has become a complex issue.",
      },
      item3: {
        title: "Problem 3",
        description:
          "Users have to authenticate repeatedly while using application systems due to lack of unified identity authentication and authorization process between systems.",
      },
    },
    ideas: {
      title: "How Authing Solves",
      item1: {
        title: "",
        subtitle:
          "Using Authing as an identity management platform can help enterprises integrate applications, unify access management, and synchronize data with one operation.",
      },
      item2: {
        title: "",
        subtitle:
          "Authing is based on RBAC and ABAC permission models, which can help enterprises achieve flexible and fine-grained access management.",
      },
      item3: {
        title: "",
        subtitle:
          "Authing supports protocols like OIDC, OAuth2, SAML, CAS, etc., which can help enterprises quickly realize unified authentication and authorization.",
      },
    },
  },
  deephow: {
    banner: {
      title: "Deephow",
      addtionTitle: "",
      subtitle: `Authing provides Deephow with a highly customized social login, providing its users with the most convenient third party login experience.`,
      brandDescript: ``,
    },
    intro: {
      title: "Customer Introduction",
      imgUrl:
        "//files.authing.co/authing-website/customer-intro-deephow-en.png",
      descript1:
        "Deephow develops an AI-powered learning platform for manufacturing, service, and repair, by turning real work into mobile ready, interactive smart video training.",
      descript2:
        "Deephow delivers a scalable solution to the skilled trade gap, using AI technology to capture and share knowledge across your organization effortlessly.",
    },
    challenge: {
      title: "Customer Challenges",
      item1: {
        title:
          "Deephow needs an excellent social login experience to simplify its users' login experience on third-party platforms such as WeChat, win form, etc., and meanwhile provide its users with a simpler and more convenient way to create accounts on third-party platforms.",
        description: "",
      },
    },
    ideas: {
      title: "How Authing Solves",
      item1: {
        title: "",
        subtitle:
          "In cooperation with Deephow, Authing provides full one-to-one consultation and technical services to support Deephow's success.",
      },
      item2: {
        title: "",
        subtitle:
          "By using the C# SDK access method, Authing provides Deephow with a highly customizable social login, bringing its users a more convenient third-party account creation & login experience.",
      },
    },
  },
  theragun: {
    banner: {
      title: "THERAGUN",
      addtionTitle: "",
      subtitle:
        "Authing helps THERAGUN build an easy-to-use unified identity authentication platform, perfect seamless application docking, and improve user experience.",
      brandDescript: ``,
    },
    intro: {
      title: "Customer Introduction",
      imgUrl:
        "//files.authing.co/authing-website/customer-intro-theragun-en.png",
      descript1:
        "THERAGUN is the largest fascia gun brand in the United States, established in 2008. Its products use the original impact therapy to deeply massage the muscles, which can relieve muscle tension, accelerate recovery, and improve body functions. At the same time, it also provides users with topical products that soothe muscles and relieve pain.",
      descript2:
        "More than 250 professional sports teams (NFL, NBA, NHL, MLB, MLS, NASCAR) worldwide trust THERAGUN, which is also used by coaches, physiotherapists, chiropractors and the general public in more than 50 countries/regions.",
    },
    challenge: {
      title: "Customer Challenges",
      item1: {
        title:
          "THERAGUN has used Shopify certification on their e-commerce website, but Shopify is not professional enough in identity authentication solutions. Taking into account the ease of use of the product, THERAGUN decided to adopt a more professional login solution to solve the complex login mode of the existing application system and achieve unified identity authentication.",
        description: "",
      },
    },
    ideas: {
      title: "How Authing Solves",
      item1: {
        title: "",
        subtitle:
          "Authing provided THERAGUN with a new unified authentication system and completed the migration of all their customers in just 7 weeks, alleviating the pressure caused by a large number of customer logins and authentications.",
      },
      item2: {
        title: "",
        subtitle:
          "With Authing's comprehensive identity authentication and access management services, THERAGUN saved a total of about 600,000 US dollars in technical labor costs and saved nearly 50% of development man-hours.",
      },
    },
  },
  bentley: {
    banner: {
      title: "Bentley",
      addtionTitle: "",
      subtitle:
        "Authing provides a seamless, convenient and secure authentication experience for Bentley internal developers and external users to ensure the security of their login and identity verification.",
    },
    intro: {
      title: "Customer Introduction",
      imgUrl:
        "//files.authing.co/authing-website/customer-intro-bentley-en.png",
      descript1:
        "Founded in 1984, Bentley Engineering Software Co., Ltd. has more than 4,000 employees, has branches in 172 countries around the world, and has annual revenues of more than 800 million U.S. dollars. It is rated as the world's second largest geographic information software solution provider.",
      descript2:
        "Bentley provides enterprises and professionals with solutions based on the design, construction and operation of roads, bridges, rail transit, water supply and drainage, public works and utilities, parks and industrial facilities.",
    },
    challenge: {
      title: "Customer Challenges",
      item1: {
        title: "Challenge 1",
        description:
          "As a global company, Bentley has completed the establishment of an identity system globally, but the identity management products used at this stage cannot meet the needs of the rapid development of Bentley’s Chinese team’s business. The Chinese team hopes to seek a domestic An excellent identity authentication provider to quickly complete the integration of existing application systems and identities.",
      },
      item2: {
        title: "Challenge 2",
        description:
          "With a single authentication access method, business security cannot be guaranteed. At present, Bentley China's business uses a single authentication method of username + password, security cannot be guaranteed, and some system password settings do not meet the password requirements, which poses security risks.",
      },
      item3: {
        title: "Challenge 3",
        description:
          "The lack of clear real-time operations and security access audits cannot meet corporate security compliance requirements. With the rapid development of business, there is a lack of real-time and effective pre-warning, in-event auditing, and post-tracing paths for user access, permission usage, and data management.",
      },
    },
    ideas: {
      title: "How Authing Solves",
      item1: {
        title: "",
        subtitle:
          "Authing provides a complete single sign-on platform, and quickly implements efficient authentication and access management functions for its Web and employee systems.",
      },
      item2: {
        title: "",
        subtitle:
          "Authing provides a variety of authentication methods Bentley options: combination, password policy, frequent login detection, custom authentication process, etc., and can be easily configured through the management console.",
      },
      item3: {
        title: "",
        subtitle:
          "Authing implements a visual security audit strategy for Bentley based on user behavior audit, administrator audit, and application access, and supports different personnel (groups) to set different password policies. Adaptive MFA allows user access to be seamless, agile and secure.",
      },
    },
  },
  futu: {
    banner: {
      title: "Futu Niuniu",
      addtionTitle: "",
      subtitle:
        "Futu Niuniu uses Authing to implement secure corporate WeChat login and scan code authentication to ensure corporate information security",
    },
    intro: {
      title: "Customer Introduction",
      imgUrl: "//files.authing.co/authing-website/customer-intro-futu-en.png",
      descript1:
        "Shenzhen Futu Network Technology Co., Ltd. was established in 2007. It is a strategic investment by Tencent and a subsidiary of NASDAQ-listed Futu Holdings (NASDAQ: FUTU). It is mainly engaged in the research and development of Internet technology products and provides services to individual investors. Market data, information, social networking and other services.",
      descript2:
        "Futu Securities and other US and Hong Kong stock brokers provide individual investors with US stocks, Hong Kong stocks, A-share stock trading, margin trading, wealth management and other services. The center builds a complete financial technology ecosystem that connects users, investors, companies, securities analysts, media, and opinion leaders.",
    },
    challenge: {
      title: "Customer Challenges",
      item1: {
        title: "",
        description:
          "Futu Company uses both Tencent Enterprise WeChat and VooV Meeting internally for daily operation and management, hoping to log in to Tencent Meeting directly through Enterprise WeChat. However,  private information such as the email, and phone number will be directly exposed if the company's WeChat own application is directly authenticated, causing corporate security risks. In addition, it is necessary to ensure that the key information of the enterprise WeChat is safe and controllable, and cannot be stored on the public network or in a third-party environment.",
      },
    },
    ideas: {
      title: "How Authing Solves",
      item1: {
        title: "",
        subtitle:
          "Employees log in to the VooV meeting through the enterprise WeChat in Authing and enter the meeting according to the different organizational structures and permissions set in the enterprise WeChat.",
      },
      item2: {
        title: "",
        subtitle: `Bridge through the "Enterprise WeChat (third-party application) scan code login" function in Authing's IDaaS product, and use the OpenID Connection protocol to achieve enterprise WeChat scan code authentication.`,
      },
    },
  },
  jcdecaux: {
    banner: {
      title: "JCDecaux",
      addtionTitle: "",
      subtitle:
        "Authing has built a unified authentication center for JCDecaux, and the identity supply function provided has helped JCDecaux complete identity management and equipment management services, forming a complete, unified and authoritative identity data source, and improving advertising efficiency by 75%.",
    },
    intro: {
      title: "Customer Introduction",
      imgUrl:
        "//files.authing.co/authing-website/customer-story-detail-intro-jcdcaux-en.png",
      descript1:
        "JCDecaux Group was founded in 1964, is the world's number one international outdoor media company, and is listed on Euronext in Paris. With operations in 3,688 cities in more than 50 countries around the world, JCDecaux entered the Chinese market in 2005, with business in 12 cities (including Hong Kong and Macau), 163,355 advertising spaces, 21% urban population coverage, and 170 million audience visits every day . There are more than 1,300 employees in China.",
      descript2:
        "As a leading outdoor advertising company in China, JCDecaux China provides the best services in the four major areas of subway media, public transportation, several games and receiving facilities media.",
    },
    challenge: {
      title: "Customer Challenges",
      item1: {
        title: "Challenge 1",
        description:
          "The security management of advertising screen equipment deployed by JCDecaux China in 12 cities is difficult. The current self-developed technology has a long implementation period and high cost.",
      },
      item2: {
        title: "Challenge 2",
        description:
          "Self-developed identity management and authorization of multiple applications such as B2B and B2E advertising platforms, as well as the completion of authorized logins for multiple applications and advertising devices, have brought great workload to the R&D team.",
      },
      item3: {
        title: "Challenge 3",
        description:
          "1000+ advertising equipment cannot achieve unified management and operation strategies, which brings a great workload to operation and maintenance personnel.",
      },
    },
    ideas: {
      title: "How Authing Solves",
      item1: {
        title: "",
        subtitle:
          "Aiming at the unified identity authentication and management issues of JCDecaux China’s self-developed advertising platform, the Authing identity cloud product is used to help employees centralize access and control of equipment, build urban regional center authentication nodes, and improve equipment authentication availability, stability and performance. At the same time, the application status is monitored in real time to ensure unified management and safety of equipment.",
      },
      item2: {
        title: "",
        subtitle:
          "Directly call Authing's API interface based on identity management to quickly implement identity supply and management within the enterprise, realize the functions of employee account and organization opening, activation, deactivation, deletion and deactivation, and provide user and organization information synchronization for downstream users.",
      },
      item3: {
        title: "",
        subtitle:
          "Access the internal application system of the enterprise to complete account synchronization, single sign-on and access authorization.",
      },
    },
  },
  "bentley-motors": {
    banner: {
      title: "Bentley",
      addtionTitle: "",
      subtitle:
        "The combination of the Authing platform's rules and mapping functions allows us to easily process any data of user login. Most importantly, we don't have to ask partners to send data in different formats, SSO can meet their needs. Authing greatly reduces our operation and maintenance workload.",
    },
    intro: {
      title: "Customer Introduction",
      imgUrl:
        "//files.authing.co/authing-website/customer-story-detail-intro-bentley-motors-en.png",
      descript1: `Bentley is one of the world's manufacturers of high-quality cars, headquartered in Crewe, UK.`,
      descript2: `"To build a fast car, a good car, the best in its class." The founder, Walter Owen Bentley, originally pursued the ultimate and excellent car-making concept.
      Nearly a century later, Mr. Bentley’s philosophy continues to guide his beliefs, actions and ambitious goals. Bentley ranks among the top British luxury cars, hand-built the world's best performance luxury wagon, Bentley was acquired by the Volkswagen Group in 1997.`,
    },
    challenge: {
      title: "Customer Challenges",
      item1: {
        title: "Challenge 1",
        description:
          "The Bentley Automotive R&D team needs to create a unified identity source within the enterprise, implement unified identity authentication and authorization functions for internal employees, improve the efficiency of R&D, and reduce the workload of operation and maintenance.",
      },
      item2: {
        title: "Challenge 2",
        description:
          "Enterprise self-developed applications, unified identity login authentication and management authorization functions cannot be reused, and the integration of new and old application identities is difficult.",
      },
      item3: {
        title: "Challenge 3",
        description:
          "For hundreds of users within the group and upstream and downstream partners, enterprise B2B, B2E container cloud platforms want to achieve a compliant and secure identity login authentication system.",
      },
    },
    ideas: {
      title: "How Authing Solves",
      item1: {
        title: "",
        subtitle:
          "Authing's unified identity solution supports multi-partner identity verification, fast and agile, and seamlessly integrates with existing applications.",
      },
      item2: {
        title: "",
        subtitle:
          "Authing Identity Cloud handles the identity verification requirements of Bentley's internal and all upstream and downstream suppliers based on a standardized workflow, making user account and secret login more secure and compliant.",
      },
      item3: {
        title: "",
        subtitle:
          "Authing helps Bentley integrate its internal self-developed application system to complete user account and secret synchronization, SSO, access authorization and Adaptive MFA.",
      },
    },
  },
  yuanqi: {
    banner: {
      title: "Yuanqi Forest",
      addtionTitle: "",
      subtitle:
        "Authing opens up Feishu products, provides us with identity source capabilities, rapid deployment and developer-friendliness, which meets our current and future needs, saves us a lot of R&D manpower, costs and cycles, and allows us to transfer these valuable More resources are used for companies and customers.",
    },
    intro: {
      title: "Customer Introduction",
      imgUrl:
        "//files.authing.co/authing-website/customer-story-detail-intro-yuanqi-en.png",
      descript1: `Yuanqi Forest Food Technology Group, established in 2016, is an innovative beverage company with independent research and development and independent design. The brand adheres to the mission of "User First", based on health needs, breaking taste barriers, and delivering the concept of healthy life. At present, Yuanqi Forest series products have covered the whole country and exported to more than 40 countries and regions including the United States, New Zealand and Singapore.`,
      descript2:
        "Yuanqi Forest has been learning the gameplay of traditional industries, and it is subverting the gameplay of traditional industries. Before 2020, the ratio of online and offline sales of Yuanqi Forest is 7:3, and in 2021, offline sales will likely surpass online. On the gold-letter brand list released by China Business News last year, Yuanqi Forest topped the list of carbonated beverages. At the same time, the annual sales of Yuanqi Forest in 2020 will also reach about 3 billion.",
    },
    challenge: {
      title: "Customer Challenges",
      item1: {
        title: "Challenge 1",
        description:
          "Yuanqi Forest currently has more than 5,000 employees’ application login management and authorization issues, and with the continuous growth of employees, traditional IAM is difficult to solve the problem of continuous expansion. How to use universal login to manage the roles and permissions of internal users to ensure that security is built into each The level system corresponding to employees is the current difficulty in the management of operation and maintenance personnel.",
      },
      item2: {
        title: "Challenge 2",
        description:
          "The integration of dozens of internal application systems, open up with the identity system, integrate Feishu, through Feishu to open up the organizational structure system, to achieve employee single sign-on, the current self-research efforts are relatively large, and the time period is long.",
      },
      item3: {
        title: "Challenge 3",
        description:
          "I hope to find an identity cloud provider to solve the ever-increasing application and staff size, and to respond to the continuous expansion of the enterprise in the future to bring sustainable growth and high efficiency.",
      },
    },
    ideas: {
      title: "How Authing Solves",
      item1: {
        title: "",
        subtitle:
          "Authing's breakthrough single sign-on technology does not require any development, and quickly helps Yuanqi Forest realize that employees can log in to all applications with one account and password, and uniformly control identity permissions.",
      },
      item2: {
        title: "",
        subtitle:
          "Authing provides identity supply for Yuanqi Forest by connecting with Feishu's product level, realizing different access levels based on Feishu's organizational structure, and saving 80% of the workload of operation and maintenance personnel.",
      },
      item3: {
        title: "",
        subtitle:
          "Authing provides a one-stop team application platform for Yuanqi Forest, realizes members and centralized management and control of access rights, creates an efficient office method, simplifies personnel and IT management, and accelerates enterprise growth.",
      },
    },
  },
  volkswagen: {
    banner: {
      title: "Volkswagen",
      addtionTitle: "",
      subtitle:
        "Authing improves our efficiency, reduces development and operation costs, and saves valuable time and resources.",
    },
    intro: {
      title: "Customer Introduction",
      imgUrl:
        "//files.authing.co/authing-website/customer-story-detail-intro-volkswagen-en.png",
      descript1:
        "Volkswagen is an automobile manufacturing company headquartered in Wolfsburg, Germany, and a core enterprise of the Volkswagen Group, one of the world's four largest automobile manufacturers. In 2019, it ranked 9th in the Fortune Global 500.",
      descript2:
        "Volkswagen inherits its excellent car-making DNA, and focuses more on the research and development of innovative smart technologies. The masses continue to break through the barriers of reality, use technology to bring their imagination to the ground, and create more possibilities for people to travel. Every interesting technology makes traveling more interesting.",
    },
    challenge: {
      title: "Customer Challenges",
      item1: {
        title: "Challenge 1",
        description:
          "Many of Volkswagen's brands and upstream and downstream partners and suppliers need to log in to many applications of the group, and the mutual recognition of identities when accessing between applications is a difficulty for the current R&D team.",
      },
      item2: {
        title: "Challenge 2",
        description:
          "There is no identity integration between old applications and newly developed applications, and accounts are isolated from each other, forming information islands. When accessing different systems, multiple authentications are required, and the user experience is poor.",
      },
      item3: {
        title: "Challenge 3",
        description:
          "Business and management increasingly require the rapid delivery of unnecessary information and application systems. Fire-fighting responses are difficult to cope with, and a unified and standardized identity system is required to support rapid delivery.",
      },
    },
    ideas: {
      title: "How Authing Solves",
      item1: {
        title: "",
        subtitle:
          "Authing's unified identity solution helped Volkswagen complete the authentication of the user's identity in the application system. Authorization management and authentication ensure that user login is safe and controllable.",
      },
      item2: {
        title: "",
        subtitle: `Authing federal authentication unites different identity providers to authenticate users through standard protocols, helps Volkswagen's upstream and downstream partners to establish trust relationships between application providers, and realizes account synchronization, single sign-on, and access authorization.`,
      },
      item3: {
        title: "",
        subtitle:
          "Authing's scalable and highly scalable SaaS platform deployment model helps Volkswagen realize the connection of multiple users and applications, as well as the needs of future application expansion.",
      },
    },
  },
  toyota: {
    banner: {
      title: "Toyota",
      addtionTitle: "",
      subtitle:
        "There is no need to rebuild or rebuild the identity login system. Through the identity source of Authing, we can quickly integrate our new and old applications, which greatly reduces the development cycle and time to market for our new applications.",
    },
    intro: {
      title: "Customer Introduction",
      imgUrl:
        "//files.authing.co/authing-website/customer-detail-intro-toyota-en.png",
      descript1:
        "Toyota Motor Corporation was established in 1937 and has a history of more than 80 years. Toyota's business in China can be traced back to 1964 when it exported the first CROWN sedans to China. For a long time, Toyota has been committed to continuously providing high-quality products and services to Chinese consumers, and earnestly fulfilling its corporate social responsibilities, thereby contributing to the sustainable development of society and the automotive industry. Today, Toyota has established 28 major wholly-owned and joint venture companies in China. In 2019, sales in China reached 1.62 million vehicles, the best record in Toyota's history in China.",
      descript2: "",
    },
    challenge: {
      title: "Customer Challenges",
      item1: {
        title: "Challenge 1",
        description:
          "The R&D team needs to develop B2C car rental business applications, and the unified identity authentication function has a long development cycle and slows down the progress of core application development.",
      },
      item2: {
        title: "Challenge 2",
        description:
          "Difficulties exist in the integration of new and old application identities. The new application of user identity authentication and management of more than ten thousand levels brings great workload to operation and maintenance.",
      },
      item3: {
        title: "Challenge 3",
        description:
          "User data security issues. The existing user management process has some management weaknesses and insufficient implementation issues, which cannot meet the requirements of industry regulatory audits.",
      },
    },
    ideas: {
      title: "How Authing Solves",
      item1: {
        title: "",
        subtitle:
          "Authing provides an identity supply source for Toyota Japan, helps Toyota R&D team quickly deploy an identity security management platform, and shortens the cycle of new application development.",
      },
      item2: {
        title: "",
        subtitle: `Authing satisfies the problem of identity login in new applications developed by Toyota and the traffic problem of C-end users of 10,000-level users.`,
      },
      item3: {
        title: "",
        subtitle:
          "Authing's self-adaptive Adaptive MFA function improves the user's complete login and enhances information security.",
      },
    },
  },
  huaxi: {
    banner: {
      title: "West China Hospital",
      addtionTitle: "",
      subtitle:
        "Authing has built an identity supply system for us to reduce information security and operational risks caused by irregular personnel identity management. Achieve technical compliance and policy compliance through the construction of an identity security management platform. We look forward to Authing bringing value to more organizations.",
    },
    intro: {
      title: "Customer Introduction",
      imgUrl:
        "//files.authing.co/authing-website/customer-detail-intro-hospital-en.png",
      descript1:
        "West China Hospital of Sichuan University (West China Hospital, Sichuan University) is a national-level center for the diagnosis and treatment of difficult, critical and critical illnesses in western China, and the largest comprehensive single-point hospital in the world. West China Hospital currently has many self-developed medical software and internal and external application systems. As a special medical industry, it has higher requirements for identity login security and unified management.",
      descript2: "",
    },
    challenge: {
      title: "Customer Challenges",
      item1: {
        title: "Challenge 1",
        description:
          "West China Hospital currently does not conduct unified management of user access rights for each system, and lacks effective technical control over user management.",
      },
      item2: {
        title: "Challenge 2",
        description:
          "The research and development cost of the identity supply system is high, and it is difficult to reuse. The scattered user management system brings great difficulty to the audit, and the operation and maintenance cost is high.",
      },
      item3: {
        title: "Challenge 3",
        description:
          "The lack of clear real-time operations and access audits cannot meet corporate compliance requirements.",
      },
    },
    ideas: {
      title: "How Authing Solves",
      item1: {
        title: "",
        subtitle:
          "In response to the needs of West China Hospital to connect to the self-developed system, Authing's application integration gateway helps West China Hospital realize application integration and identity source management.",
      },
      item2: {
        title: "",
        subtitle: `Provide audit logs and records related to user identity sources to facilitate administrators to trace back.`,
      },
      item3: {
        title: "",
        subtitle:
          "Authing provides authentication and authorization of a unified identity management platform to help West China Hospital achieve single sign-on, making it easier for users to log in and reducing operation and maintenance costs.",
      },
    },
  },
  bosch: {
    banner: {
      title: "BOSCH",
      addtionTitle: "",
      subtitle:
        "Authing is developer-friendly, quick to implement, and has low infrastructure requirements. Their simple demonstrations and professional knowledge make Authing very attractive, which greatly helps us save deployment time, cost and development cycle.",
    },
    intro: {
      title: "Customer Introduction",
      imgUrl:
        "//files.authing.co/authing-website/customer-detail-intro-bosch-en.png",
      descript1:
        "The Bosch Group is one of the German industrial companies and the world's largest supplier of automotive technology. It is engaged in the industries of automotive and intelligent transportation technology, industrial technology, consumer goods and energy and construction technology. The number of employees exceeds 270,000 in more than 50 countries. Bosch is well-known for its innovative and cutting-edge products and system solutions.",
      descript2: "",
    },
    challenge: {
      title: "Customer Challenges",
      item1: {
        title: "Challenge 1",
        description:
          "It is a problem that the group is currently facing to manage the expanding customers and all kinds of equipment that are constantly being introduced to the market.",
      },
      item2: {
        title: "Challenge 2",
        description:
          "Regarding the connection between Bosch users and devices, how to perform identity verification, and to ensure access security and permissions have caused great troubles to the R&D team.",
      },
      item3: {
        title: "Challenge 3",
        description:
          "A large amount of duplicate user data needs to be redundantly stored and synchronized management, how to quickly adjust the user change problem caused by equipment business and other reasons.",
      },
    },
    ideas: {
      title: "How Authing Solves",
      item1: {
        title: "",
        subtitle:
          "Authing's unified identity solution helped Bosch Group complete the authentication of all devices and user identities. Authorization management and authentication ensure that user login is safe and controllable.",
      },
      item2: {
        title: "",
        subtitle: `The Authing platform provides the synchronization of user and device information to the downstream, and helps the Bosch Group realize multi-user and multi-device connections to solve the needs of application expansion.`,
      },
      item3: {
        title: "",
        subtitle:
          "Access the internal application system of the enterprise to complete account synchronization, single sign-on and access authorization.",
      },
    },
  },
  pingcap: {
    banner: {
      title: "PingCAP",
      addtionTitle: "",
      subtitle:
        "High-tech innovative products, flexible and agile, fast response speed. Unexpectedly, the upstream and downstream needs of our more than 40 applications such as single sign-on, collaborative office, and identity-based supply were quickly met with Authing products.",
    },
    intro: {
      title: "Customer Introduction",
      imgUrl:
        "//files.authing.co/authing-website/customer-detail-intro-pingcap-en.png",
      descript1: `PingCAP is an enterprise-level open source distributed database manufacturer, providing services including open source distributed database products, solutions and consulting, technical support and training certification. TiDB, a distributed relational database created by PingCAP, is built for key enterprise businesses. It has enterprise-level core features such as "distributed strong consistent transactions, online elastic horizontal expansion, high availability with self-recovery, and multiple activities across data centers". Help companies maximize the value of data and fully release the company's growth space. At present, PingCAP has provided services to more than 1,500 companies in countries and regions including China, the United States, Europe, Japan, Southeast Asia, etc., involving multiple industries such as finance, operators, manufacturing, retail, Internet, and government.`,
      descript2: "",
    },
    challenge: {
      title: "Customer Challenges",
      item1: {
        title: "Challenge 1",
        description:
          "PingCAP has had multiple employee identity sources for 3 years, and there are difficulties in company organization and cross-platform management, including single sign-on and collaboration between nearly 40 applications such as Feishu, Beisen, and Google. Office and organizational management needs.",
      },
      item2: {
        title: "Challenge 2",
        description:
          "PingCAP has offices in many countries at home and abroad. How to manage the identity of employees in various countries and reduce the cost of identity management and operation is an urgent problem to be solved at this stage.",
      },
      item3: {
        title: "Challenge 3",
        description:
          "PingCAP hopes that the Beisen HR system can be used as a unified identity source for the company to automate the management of employees at home and abroad, and to build an identity platform to manage and synchronize employee information and organizational structures.",
      },
    },
    ideas: {
      title: "How Authing Solves",
      item1: {
        title: "",
        subtitle:
          "Based on the OIDC and SAML protocols, Authing helps PingCAP connect with all existing applications, and the identity supply of Authing helps PingCAP realize the single sign-on SSO function, enabling the use of one account to log in to all enterprise applications.",
      },
      item2: {
        title: "",
        subtitle: `Based on the SCIM and LDAP protocols, it can realize the organization's supply capability and Authing identity supply capability, and realize the ability of PingCAP's employee identity upstream and downstream synchronization supply, which is scalable and highly available.`,
      },
      item3: {
        title: "",
        subtitle:
          "Authing's product capabilities for employee entry and exit management and information synchronization have helped PingCAP greatly reduce operation and maintenance time and costs.",
      },
    },
  },
  "alpha-cen": {
    banner: {
      title: "Alpha Cen",
      addtionTitle: "",
      subtitle:
        "Experience with Apple and Texas Instruments shows that unified identity management should begin early. Authing offers 1000+ API, along with comprehensive documentation, enabling us to create an IAM system with minimal effort.",
    },
    intro: {
      title: "Customer Introduction",
      imgUrl: "",
      descript1:
        "Alpha Cen is a high-tech startup based in Silicon Valley. The founding team consists of graduates from the California Institute of Technology, Stanford University, Apple, and Texas Instruments, with full-stack research and development capabilities ranging from fundamental materials, device innovation, chip design, to stable end products.",
      descript2:
        "The founding team has 10 years of experience in globally renowned laboratories in nanophotonics and nanofabrication, as well as 10 years of experience in hardware and integrated circuit architecture design at top companies in the industry. They have released multiple chips for industrial, consumer, and automotive markets, which have been widely used in products such as Google data centers, Tesla Model 3, and LG OLED TVs.",
    },
    challenge: {
      title: "Customer Challenges",
      item1: {
        title: "Problem One",
        description:
          "Multiple applications were adopted after the company's establishment, but lack of data interoperability hindered unified management of identity authentication and permission issues.",
      },
      item2: {
        title: "Problem Two",
        description:
          "Due to the involvement of numerous applications, the CEO values the flexibility of interfaces, hoping to integrate applications quickly and reduce the cost of developing.",
      },
      item3: {
        title: "Problem Three",
        description:
          "When acquiring systems, long launch cycles and high learning costs are common problems. The CEO aims to find a product that is easy to set up and requires minimal manpower investment.",
      },
    },
    ideas: {
      title: "How Authing Solves",
      item1: {
        title: "",
        subtitle:
          "Building an identity management platform through Authing can help enterprises unify their identity sources of multiple systems and automate the synchronization of data efficiently.",
      },
      item2: {
        title: "",
        subtitle:
          "Authing pre-integrated with 2000+ applications, which can help enterprises quickly connect Feishu, Ding Talk, WeCom and other software quickly.",
      },
      item3: {
        title: "",
        subtitle:
          "With Authing, enterprises can complete the release and operation of the system based on technical docs, and the learning cost and docking cost are extremely low.",
      },
    },
  },
  nreal: {
    banner: {
      title: "Nreal",
      addtionTitle: "",
      subtitle:
        "Our AR glasses launch event was a great success, and the number of users is steadily increasing, with the system running smoothly. We would like to thank Authing for their patience in giving us strong support!",
    },
    intro: {
      title: "Customer Introduction",
      imgUrl: "",
      descript1:
        "Nreal was founded in 2017 and is the first company to launch consumer-grade AR glasses globally. It has been widely recognized for its excellent display technology and product design, and has established partnerships with more than 10 global well-known operators and has brought its products to 6 countries.",
      descript2:
        "In 2021, Nreal's market share reached 75%, and in the first half of 2022 it rose to 81%, becoming the top-selling domestic AR glasses brand in the world.",
    },
    challenge: {
      title: "Requirement Challenges",
      item1: {
        title: "Problem One",
        description:
          "All terminals require a unified identity system. However, the development of three terminals involves multi-language development, and the development cost is high.",
      },
      item2: {
        title: "Problem Two",
        description:
          "Considering future user growth and business expansion, the identity platform must be able to provide high concurrency, secure and stable performance, and high scalability.",
      },
      item3: {
        title: "Problem Three",
        description:
          "We have used mature IDaaS overseas, but now that we're entering the Chinese mainland market, we need an IDaaS that complies with Chinese regulations and ecosystems.",
      },
    },
    ideas: {
      title: "Turning Ideas into Reality",
      item1: {
        title: "",
        subtitle:
          "Authing offers over 1000 APIs and multi-language SDKs, which can flexibly adapt to different scenarios, to achieve identity unification of three terminals, and saving development workload.",
      },
      item2: {
        title: "",
        subtitle: `Authing's cloud-native architecture enables it to handle up to 1 million logins and visits in just 3 minutes. Additionally, enterprises can use automated pipelines to establish a basis for precision marketing.`,
      },
      item3: {
        title: "",
        subtitle:
          "Authing's unified identity foundation helps developers quickly integrate with applications, and it is in line with Chinese ecology and regulations. It's a perfect replacement for foreign products.",
      },
    },
  },
  cocacola: {
    banner: {
      title: "Coca Cola",
      addtionTitle: "",
      subtitle:
        "We are currently large in addition to many users, involving dozens of application systems, delete, account lifecycle management, etc., the workload is huge, and it is easy to leak to cause safety hazards. Authing help us solve the challenge of identity.",
    },
    intro: {
      title: "Customer Introduction",
      imgUrl:
        "//files.authing.co/authing-website/customer-detail-intro-cocacola-en.png",
      descript1:
        "Taikoo Coca-Cola is a full-class beverage company that provides more than 500 brands of drinks in more than 200 countries and regions. From reducing sugar in the beverage to introducing innovative products, the company's product portfolio continues to introduce new. Coca-Cola has been committed to reducing the environmental impact, working hard to promote water feedback and packaging recycling. In China, Taikoo Coca-Cola provides consumers with more than 20 brands, more than 100 kinds of beverages for drinks. There are 46 factories in Hua, with more than 49,000 system employees. At the same time as business continues to develop, Coca-Cola China and bottling partners are also committed to achieving the sustainable development of local society, and consumer multivariate beverage demand, care about the quality of the product, and carefully the development of the environment.",
      descript2: "",
    },
    challenge: {
      title: "Customer Challenges",
      item1: {
        title: "Challenge 1",
        description:
          "IT operations under various states of more than 20,000 employees in China (including Hong Kong), allowing IT operation and maintenance managers to face great challenges, including personnel entering post, transfer, part-time, return and other account management bullets open and recycle lag And there is no unified authorization management.",
      },
      item2: {
        title: "Challenge 2",
        description:
          "There are dozens of old applications in the enterprise unable to complete identity: enterprises begin to seek solutions in six or seven years ago, and they can't completely solve the problems of many years after more than a dozen types of suppliers turned over.",
      },
      item3: {
        title: "Challenge 3",
        description:
          "Employees need to remember dozens of username / passwords, password strategies, and have diverse certification methods. When accessing different systems, you need multiple certifications, and the employee experience is not good.",
      },
    },
    ideas: {
      title: "How Authing Solves",
      item1: {
        title: "",
        subtitle:
          "The unified login scheme provided by Authing, through employee account synchronization, employee accounts for dozens of applications such as AD, AAD, Enterprise WeChat, and Self-Research Systems, to log in to all applications for Coca-Cola. WeChat account.",
      },
      item2: {
        title: "",
        subtitle: `Authing help Coca-Cola realizes the company's WeChat scan code login, solves the employee multi-account, multi-password, multi-application to switch the pain points of the login, improve employee satisfaction and experience.`,
      },
      item3: {
        title: "",
        subtitle:
          "Authing Automation Account Life Cycle Management Instead of Coca-Cola Current manual account management, batch management employees enter the post, authorized application and color, deactivate, archive, delete, organizational architecture adjustment, etc. Establish a single identity to synchronize attribute information in a unified directory, output unique standard data outward, facilitate IT management.",
      },
    },
  },
  csdn: {
    banner: {
      title: "CSDN",
      addtionTitle: "",
      subtitle:
        "Authing's out-of-the-box API/SDK helped us shorten one month of development cycle and build a powerful One-ID identity management platform, greatly improving user experience.",
    },
    intro: {
      title: "Customer Introduction",
      imgUrl:
        "//files.authing.co/authing-website/customer-detail-intro-cocacola-en.png",
      descript1:
        "Founded in 1999, CSDN (China Software Developer Network) is a well-known Chinese developer website worldwide. Adhering to the mission of empowering one hundred million technical talents, CSDN provides comprehensive services for developers' ecosystem, IT knowledge learning, talent recruitment, R&D efficiency, and collaborative management for technology companies. With a community-based foundation, CSDN serves over 35 million registered users, 10 million monthly active users, covering more than 90% of Chinese developers and 70% of IT professionals.",
      descript2: "",
    },
    challenge: {
      title: "Customer Challenges",
      item1: {
        title: "Challenge 1",
        description:
          "The task of building a user identity management system is arduous. It is difficult to complete development within a short project cycle.",
      },
      item2: {
        title: "Challenge 2",
        description:
          "Considering the future expansion of the platform, CSDN hopes to provide users with more social login methods, and forming a unified identity management strategy for One-ID.",
      },
      item3: {
        title: "Challenge 3",
        description:
          "Platform operation involves multiple parties' cooperation, which requires ensuring operational openness while protecting the security of identity data.",
      },
    },
    ideas: {
      title: "How Authing Solves",
      item1: {
        title: "",
        subtitle:
          "Authing provides 1000+ API/SDK for mainstream programming languages, helping CSDN shorten the development cycle by one month.",
      },
      item2: {
        title: "",
        subtitle: `Authing Guard, social login options and third-party identity associations allow for highly customized user login experience and unified One-ID identity management.`,
      },
      item3: {
        title: "",
        subtitle:
          "Authing's PBAC model enables granular permission management and supports unified organization and user role management through interfaces.",
      },
    },
  },
  unicredit: {
    banner: {
      title: "UniCredit S.P.A.",
      addtionTitle: "",
      subtitle:
        "Authing's out-of-the-box API/SDK helped us shorten one month of development cycle and build a powerful One-ID identity management platform, greatly improving user experience.",
    },
    intro: {
      title: "Customer Introduction",
      imgUrl:
        "//files.authing.co/authing-website/customer-detail-intro-cocacola-en.png",
      descript1:
        "UniCredit Bank, headquartered in Milan, Italy, is a European bank and one of the largest banking groups in Europe. It is listed on the Milan Stock Exchange and its core business is in Italy, southern Germany, Austria, and other regions. UniCredit Bank provides personal investment, commercial banking, international business, telephone services, credit cards, deposit and loan services, and has more than 40 million users in 22 countries.",
      descript2:
        "UniCredit Bank also has a large number of businesses in Central and Eastern Europe. According to the total assets, UniCredit Bank, with 91 billion euros in assets, is the largest bank group in the euro zone, the third largest in Europe, and the sixth largest in the world.",
    },
    challenge: {
      title: "Customer Challenges",
      item1: {
        title: "Challenge 1",
        description:
          "UniCredit values data security highly and aims to ensure employees can securely and compliantly access internal applications.",
      },
      item2: {
        title: "Challenge 2",
        description:
          "They require more sophisticated identity management capabilities. However, in-house development is difficult, time-consuming, and costly.",
      },
      item3: {
        title: "Challenge 3",
        description:
          "As a financial institution dealing with a large volume of user privacy information, the bank can not support public cloud deployment.",
      },
    },
    ideas: {
      title: "How Authing Solves",
      item1: {
        title: "",
        subtitle:
          "Authing has diverse MFA methods and adaptive security policies that enable enterprises achieving more secure login authentication.",
      },
      item2: {
        title: "",
        subtitle: `Authing provides 1000+ APIs/SDKs related to identity authentication and permission management, which can help enterprises deploy complex functions in a short time.`,
      },
      item3: {
        title: "",
        subtitle:
          "Authing adopts Kubernetes and supports public cloud, hybrid cloud, and private cloud deployment. It also has a minute-level elastic scaling capability.",
      },
    },
  },
};
